import React from 'react'
import { Divider, Typography } from '@mui/material'
import PropTypes from 'prop-types'

/**
 *
 * @param {Object} props
 * @param {import('../../../types/order.type').OrderModel} props.order
 */
function OrderDetails(props) {
  return (
    <table style={{ width: '100%' }}>
      <thead>
        <tr>
          <td colSpan={4}>
            <Divider sx={{ mb: 1.5, width: '100%' }} />
          </td>
        </tr>
        <tr>
          <th style={{ width: '40%', textAlign: 'left' }}>Order Summary</th>
          <th style={{ width: '20%' }}>Price</th>
          <th style={{ width: '20%' }}>Quantity</th>
          <th style={{ width: '20%' }}>Amount</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td colSpan={4}>
            <Divider sx={{ marginTop: 1.5, width: '100%' }} />
          </td>
        </tr>
        {props.order.items.map((planItem, index) => (
          <tr key={index}>
            <td style={{ paddingTop: '1em' }}>
              {planItem.name}
              <br />
              <Typography style={{ fontSize: '14px', color: '#818D9C' }}>
                {planItem.data +
                  'GB, ' +
                  planItem.voice +
                  ' talktime, ' +
                  planItem.sms +
                  ' SMS'}
              </Typography>
            </td>
            <td style={{ textAlign: 'center', paddingTop: '1em' }}>
              {/* current plan construct does not aggregate price */}
              {/* ${planItem?.price.toFixed(2)}/month */}
            </td>
            <td style={{ textAlign: 'center', paddingTop: '1em' }}>
              {planItem.quantity}
            </td>
            <td style={{ textAlign: 'center', paddingTop: '1em' }}>
              {/* current plan construct does not aggregate price */}
              {/* ${(planItem?.price * planItem.quantity).toFixed(2)} */}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}

OrderDetails.propTypes = {
  order: PropTypes.object
}

export default OrderDetails
